// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"2825f04d","346":"6db37ce6","624":"2c3c52de","862":"e5836f0f"}[chunkId] + ".chunk.js";
};